export const trimCharsDynamic = (str, numChars) => {
  if (!str) return "NO USER";
  if (str?.length <= numChars * 2) {
    return str;
  }
  //   const middleChars = str.length - numChars * 2;
  const startChars = str?.slice(0, numChars);
  const endChars = str?.slice(-numChars);
  return `${startChars}...${endChars}`;
};

export function getTotalEthSolObjects(nftList) {
  if (nftList == undefined || nftList == null || nftList?.length == 0) return 0;
  let totalEthSolObjects = 0;
  nftList?.forEach((nft) => {
    if (
      nft?.eth &&
      Object.keys(nft?.eth).length !== 0 &&
      nft?.sol &&
      Object.keys(nft?.sol).length !== 0
    ) {
      totalEthSolObjects += 2;
    } else if (
      (nft?.eth && Object.keys(nft?.eth).length !== 0) ||
      (nft?.sol && Object.keys(nft?.sol).length !== 0)
    ) {
      totalEthSolObjects++;
    }
  });

  return totalEthSolObjects;
}

export function getBoostedNftCount(nfts) {
  let totalEthSolObjects = 0;

  nfts?.staked?.forEach((nft) => {
    if (nft?.eth || nft?.sol) {
      if (
        nft?.eth != "" &&
        Object.keys(nft?.eth).length !== 0 &&
        nft?.sol != "" &&
        Object.keys(nft?.sol).length !== 0
      ) {
        totalEthSolObjects++;
      }
    }
  });

  return totalEthSolObjects;
}
